<app-autocomplete
  [control]="control"
  [itemsSource]="items"
  [helpText]="'Inneh&aring;ller lediga objekt med upplåtelseform bostadsrätt. Objekt som inte har ett aktivt kontrakt &auml;r lediga.'"
></app-autocomplete>
